import { MobiDocument } from './MobiDocument';

export class EtablissementScolaireNiveauDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private etablissementscolaire_id : number;
    private niveauscolaire_id : number;

    constructor(etabScolaireNiveau:any) {
        super();
        this._id = etabScolaireNiveau._id;
        this._rev = etabScolaireNiveau._rev;
        this.id = etabScolaireNiveau.id;
        this.etablissementscolaire_id = etabScolaireNiveau.etablissementscolaire_id;
        this.niveauscolaire_id = etabScolaireNiveau.niveauscolaire_id;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getEtablissementscolaire_id(): number {
        return this.etablissementscolaire_id;
    }

    public setEtablissementscolaire_id(etablissementscolaire_id: number): void {
        this.etablissementscolaire_id = etablissementscolaire_id;
    }

    public getNiveauscolaire_id(): number {
        return this.niveauscolaire_id;
    }

    public setNiveauscolaire_id(niveauscolaire_id: number): void {
        this.niveauscolaire_id = niveauscolaire_id;
    }

    
    
}